import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import moment from "moment";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import AppRating from "../../components/Common/AppRating";
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import SearchBar from "../../components/Common/Searchbar";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomDateRangePicker from "../../components/Form/CustomDateRangePicker";
import CustomIconButton from "../../components/Form/CustomIconButton";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import Helpers from "../../helpers/helpers";
import { getReviewExport, getReviewListing, resetReviewDocumentState, resetReviewState } from "../../store/actions";

const ReviewManagement = ({ userPermission, reviewListing, reviewExportDocument }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(resetReviewState());
    }, []);

    const [loading, setIsLoading] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [filterObject, setFilterObject] = useState({ startDate: '', endDate: '', status: '0', rating: '0' });
    const [dateRange, setDateRange] = useState([null, null]);
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("desc");
    const [sort_by, setSortBy] = useState("created_at");
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [dateModalOpen, setDateModalOpen] = useState(false);
    const [exportable, setExportable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const [approveable, setApproveable] = useState(false);
    const searchRef = useRef();

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("export-review") && setExportable(true);
            userPermission?.includes("view-review") && setViewable(true);
            !userPermission?.includes("view-review") && navigate('/not-authorized');
            userPermission?.includes("approve-review") && setApproveable(true);
        }
    }, [userPermission]);

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword]);

    useEffect(() => {
        initData();
    }, [length, page, sort, sort_by, filterObject]);

    useEffect(() => {
        if (reviewExportDocument?.code === 'success' && reviewExportDocument?.excel_base64) {
            Helpers.handleDownloadExcelFile(reviewExportDocument.excel_base64, 'rating_listing');
            dispatch(resetReviewDocumentState());
        }
        setIsLoading(false);
    }, [reviewExportDocument])

    const statusList = [
        { value: "0", label: "All statuses" },
        { value: "pending_approval", label: "Pending approval" },
        { value: "approved", label: "Published" },
        { value: "rejected", label: "Rejected" }
    ]

    const ratingList = [
        { value: "0", label: "All ratings" },
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "4", label: "4" },
        { value: "5", label: "5" },
    ]

    const header = [
        {
            Header: "Submitted date",
            columnID: "created_at",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {cellProps?.created_at && moment(cellProps.created_at).format("DD MMM YYYY")}
                        <br /> {cellProps?.created_at && <span style={{ color: "#A0A0A0" }}>{moment(cellProps.created_at).format("hh:mm A")}</span>}
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Order ID",
            columnID: "order_id",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div>#{cellProps?.order_id || '-'}</div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Product",
            columnID: "product",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.product_name}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Customer",
            columnID: "customer",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.customer_name}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Rating",
            columnID: "rating",
            accessor: (cellProps) => {
                return (<React.Fragment><AppRating rating={cellProps?.rating || 0} /></React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Status",
            columnID: "status",
            accessor: (cellProps) => {
                return (<React.Fragment><Label.ReviewStatusLabel label={cellProps?.status} marginLeft={"0px"} /></React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {viewable && <Link to={`/view-review/${cellProps.id}`}>
                            <CustomIconButton
                                iconName={'ri-eye-line'}
                                onClick={() => { '' }}
                            />
                        </Link>}
                    </React.Fragment>
                )
            },
            minWidth: 20,
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    const initData = () => {
        dispatch(getReviewListing({
            page: page,
            size: length,
            status: filterObject?.status,
            from_date: filterObject?.startDate,
            to_date: filterObject?.endDate,
            rating: filterObject?.rating,
            sort: sort,
            sort_by: sort_by,
            search: searchRef.current
        }))
    }

    const resetFilter = () => {
        setPage("1");
        setFilterObject({ startDate: '', endDate: '', status: '0', rating: '0' });
        setSearch('');
    }

    const handleFilterChange = (key, value) => {
        setFilterObject((prevValues) => ({
            ...prevValues,
            [key]: value
        }));
    };

    const handleExport = () => {
        let filter = {
            status: filterObject?.status,
            from_date: filterObject?.startDate,
            to_date: filterObject?.endDate,
            rating: filterObject?.rating,
            // search: keyword
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all' || filter[key] === "0") {
                delete filter[key];
            }
        });
        setIsLoading(true);
        dispatch(getReviewExport({
            filter: filter,
            sort: sort_by,
            sort_order: sort,
            search: searchRef.current
        }));
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    const handleSetDateRange = (e) => {
        setPage("1");
        if (e) {
            setDateRange(e);
            handleFilterChange('startDate', moment(e[0]).format('YYYY-MM-DD'));
            handleFilterChange('endDate', moment(e[1]).format('YYYY-MM-DD'));
        } else {
            setDateRange(null);
            handleFilterChange('startDate', null);
            handleFilterChange('endDate', null);
        }
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid item container lg={10} md={12} style={{ display: 'flex', alignItems: "center" }} spacing={1}>
                    <Grid item lg={2} md={2} xs={12}>
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item lg={4} md={4} xs={12}  >
                        <CustomDateRangePicker
                            open={() => setDateModalOpen(true)}
                            close={() => setDateModalOpen(false)}
                            isOpen={dateModalOpen}
                            startDate={(filterObject?.startDate && moment(filterObject?.startDate).format('DD MMM YYYY')) || 'dd/mm/yyyy'}
                            endDate={(filterObject?.endDate && moment(filterObject?.endDate).format("DD MMM YYYY")) || 'dd/mm/yyyy'}
                            handleSetDateRange={handleSetDateRange}
                            value={dateRange}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} xs={12}  >
                        <CustomSelect2
                            values={filterObject?.status || "-1"}
                            onChange={(e) => { setPage("1"); handleFilterChange('status', e) }}
                            data={statusList}
                            placeholder={"All statuses"}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} xs={12} >
                        <CustomSelect2
                            values={filterObject?.rating || "-1"}
                            onChange={(e) => { setPage("1"); handleFilterChange('rating', e) }}
                            data={ratingList}
                            placeholder={"All ratings"}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} xs={12} >
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                {exportable && <Grid item lg={2} md={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }} alignItems={'center'}>
                    <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />
                </Grid>}
            </Grid>
        )
    }

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between align-items-center p-1 pb-2">
                <div className="header d-flex">Review <div className="header-amount mx-2">{reviewListing?.data?.total || 0}</div></div>
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content" style={{ minHeight: 850 }}>
                <LoadingDialog open={loading || !reviewListing?.data?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    {renderHeader()}
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={reviewListing?.data?.data || []}
                        pageSize={length}
                        totalPage={reviewListing?.data?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={reviewListing?.data?.last_page || 1}
                    />
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Review }) {
    return {
        userPermission: Login.permissionArry,
        reviewListing: Review.reviewListing,
        reviewExportDocument: Review.exportReview,
    };
}

export default connect(mapStateToProps)(ReviewManagement);
